import { BehaviorSubject } from 'rxjs';
export const isB2bPage$ = new BehaviorSubject(false);
export const b2bPageHierarchy$ = new BehaviorSubject([]);
//# sourceMappingURL=store-b2b.js.map